export const getStyled = (theme) => ({
  menuReaction: {
    '& .MuiListPadding': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  reactionMenuContainer: {
    outline: 'none',
    width: 'fit-content',
    height: 'auto',
    padding: 0,
    display: 'flex',
    justifyContent: 'space-between',
  },
  emojiBox: {
    '& .emoji-mart': {
      border: 'none',
      borderRadius: 8,
      backgroundColor: 'transparent',
      height: '100%',
      overflow: 'hidden',
    },
    '& .emoji-mart-category': {
      display: 'block',
    },
    '& .emoji-mart-category:nth-child(2)': {
      display: 'block !important',
    },
    '& .emoji-mart-category-label': {
      display: 'none',
    },
    '& .emoji-mart-dark .emoji-mart-bar': {
      display: 'none',
    },
    '& .emoji-mart-bar': {
      marginTop: 0,
    },
    '& .emoji-mart-search': {
      marginTop: 0,
    },
    '& .emoji-mart-search input': {
      display: 'none',
    },
    '& .emoji-mart-category-label span': {
      display: 'none',
    },
    '& .emoji-mart-scroll': {
      height: 'auto',
      maxHeight: '240px',
      scrollbarWidth: 'none',
      paddingLeft: 0,
      '&::WebkitScrollbar': {
        display: 'none',
      },
      msOverflowStyle: 'none',
    },
    '& .emoji-mart-search-icon': {
      display: 'none',
    },
    '& .emoji-mart-category-list': {
      display: 'grid',
      width: '100% !important',
      height: 'auto',
      gridTemplateColumns: 'repeat(10, 1fr)',
      gap: 0,
    },
    '& .emoji-mart-emoji': {
      padding: 0,
      margin: '4px',

      span: {
        fontSize: '24px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'maxContent',
        width: 'maxContent',
        padding: '5px 3px',
        transform: 'translateY(-10%)',

        '& hover': {
          backgroundColor: '#c4c4c4',
        },
      },
    },
    '& .emoji-mart-category-list li': {
      display: 'flex',
    },
  },
  buttonExpand: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    border: 'none',
    borderRadius: '50%',
    fontSize: '1.5rem',
    minWidth: 'auto',
    maxHeight: 'max-content',
    padding: '2px',
    margin: '6px 6px 0 0',
    color: 'white',
  },

  dialog: {
    '& .MuiDialogPaper': {
      width: '400px',
      maxWidth: '400px',
    },
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeButton: {
    padding: 4,
  },

  cancelButton: {
    backgroundColor: theme.custom.colors.cancelButton,
    color: '#FFF',
  },

  saveButton: {
    backgroundColor: theme.custom.colors.confirmButton,
    color: '#FFF',
  },

  editButton: {
    backgroundColor: theme.custom.colors.editButton,
    color: '#FFF',
  },
});
